import RecruitmentPoolInput from 'domain/recruiting/recruitmentPool/shared/input/RecruitmentPoolInput';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';

const fieldSx = {
  '& .floating-label-input, & .floating-label-baseInput, & .floating-label-dropdown': { mb: 0 },
};

export const getActivatePositionFillRequestSections = (): CreateEditFormSection[] => [
  {
    id: 'recruitment-pool',
    fields: [
      {
        id: 'recruitmentPoolId',
        size: { xs: 12, md: 7, xl: 7 },
        sx: fieldSx,
        content: <RecruitmentPoolInput isRequired />,
      },
    ],
  },
];
